import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <p className="font-mono-logs text-[#00f0ff] text-sm">[ === ] cargando...</p>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
